module.exports = __webpack_public_path__ + "img/icon.67c63037.png";